"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeletePunch = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const paths_1 = require("../../paths");
const eventEmitter_1 = require("../../utils/EventEmitter/eventEmitter");
const taaEvents_1 = require("../../utils/EventEmitter/taaEvents");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const logger_1 = require("../../logger");
function useDeletePunch({ employeeId, useV2Api, usageLocation }) {
    const { clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const { isLoading: loading, error, mutate } = (0, react_query_1.useMutation)((0, fetchClient_1.submitData)(currentStage));
    const [data, setData] = (0, react_1.useState)('');
    const [retryParams, setRetryParams] = (0, react_1.useState)();
    const path = useV2Api
        ? (0, paths_1.SUBMIT_DELETE_PUNCH_V2_API)(employeeId || '')
        : (0, paths_1.DELETE_PUNCH_API)(employeeId || '');
    const method = useV2Api ? 'POST' : 'PATCH';
    const apiName = useV2Api ? 'deletePunchV2' : 'deletePunch';
    const deletePunch = (punchDateTime) => {
        setRetryParams(undefined);
        setData('');
        mutate({
            path,
            method,
            body: {
                employeeId,
                punchDateTime
            },
            metaData: {
                apiName,
                clientName
            },
            usageLocation
        }, {
            onSuccess: () => {
                eventEmitter_1.Emitter.emit(taaEvents_1.taaEvents.DELETE_PUNCH, { responseCode: 200 });
                logger_1.logger.emitCountMetric({
                    metricName: logger_1.METRICS.PUNCH_DELETE_REQUEST_SUCCESS.COUNT,
                    dimensions
                });
                setData(punchDateTime);
            },
            onError: (err) => {
                eventEmitter_1.Emitter.emit(taaEvents_1.taaEvents.DELETE_PUNCH, {
                    data: err,
                    responseCode: err.statusCode || 500
                });
                logger_1.logger.emitCountMetric({
                    metricName: logger_1.METRICS.PUNCH_DELETE_REQUEST_ERROR.COUNT,
                    dimensions
                });
                setRetryParams({
                    punchDateTime
                });
            }
        });
    };
    const retry = () => {
        if (!retryParams || loading)
            return;
        const { punchDateTime } = retryParams;
        deletePunch(punchDateTime);
    };
    return {
        deletePunchState: {
            data,
            loading,
            error: retryParams ? error : null,
            retry
        },
        deletePunch
    };
}
exports.useDeletePunch = useDeletePunch;
